import { render, staticRenderFns } from "./AdditiveTable.vue?vue&type=template&id=d01fc0a8&scoped=true"
import script from "./AdditiveTable.vue?vue&type=script&lang=js"
export * from "./AdditiveTable.vue?vue&type=script&lang=js"
import style0 from "./AdditiveTable.vue?vue&type=style&index=0&id=d01fc0a8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01fc0a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d01fc0a8')) {
      api.createRecord('d01fc0a8', component.options)
    } else {
      api.reload('d01fc0a8', component.options)
    }
    module.hot.accept("./AdditiveTable.vue?vue&type=template&id=d01fc0a8&scoped=true", function () {
      api.rerender('d01fc0a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/additive/AdditiveTable.vue"
export default component.exports